/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import styles from "./styles.css";
import { Label } from "@cars24/turbo-web/lib/label";
import ProgressStepper from "@cars24/turbo-web/lib/progress-stepper";
import { Button } from "@cars24/turbo-web/lib/button";
import PropTypes from "prop-types";
import { SF_CMS_IMAGE_SLUGS } from "../../../constants/sf-landing-constants";

const LoanApplicationSteps = ({ content, images, onApply, isBtnLoading }) => {
    const { tokens } = useTokens();
    const { title = "", subtitle = "", cta = "", steps = [] } = content || {};

    const stepsList = useMemo(
        () =>
            steps.map((step, index) => ({
                ...step,
                id: index,
                state: "ongoing"
            })),
        [steps]
    );

    const stepImage = useMemo(
        () =>
      images?.filter(
          (img) => img.imageSlug === SF_CMS_IMAGE_SLUGS.STEPS_BANNER
      )?.[0] || {},
        [images]
    );

    return (
        <div styleName={"styles.loanApplicationStepsContainer"}>
            <div styleName={"styles.container"}>
                <Heading
                    level={NUMBER.TWO}
                    color={tokens.text_default_text_primary}
                    isBold
                >
                    {title || ""}
                </Heading>
                <Label level={NUMBER.TWO} color={tokens.text_default_text_primary}>
                    {subtitle || ""}
                </Label>
                <div styleName={"styles.mainContainer"}>
                    <div styleName={"styles.stepperContainer"}>
                        <ProgressStepper orientation="vertical" items={stepsList} />
                        <div styleName={"styles.btnContainer"}>
                            <Button
                                label={cta || ""}
                                size="large"
                                onClick={onApply}
                                loading={isBtnLoading}
                            />
                        </div>
                    </div>
                    <img
                        src={stepImage?.desktopImage}
                        width={600}
                        height={552}
                        styleName={"styles.mainImg"}
                        alt="loan steps"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    );
};

LoanApplicationSteps.propTypes = {
    content: PropTypes.object,
    images: PropTypes.array,
    onApply: PropTypes.func,
    isBtnLoading: PropTypes.bool
};

export default LoanApplicationSteps;
